"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IKDContentBonus = exports.MJIAnimalsInfo = exports.MJIAnimals = exports.BNpcName = exports.IKDSpotInfo = exports.IKDRouteInfo = exports.Achievement = exports.IKDFishInfo = exports.ItemName = exports.FishParameter = exports.Item = exports.FishingSpot = exports.PlaceName = exports.IKDRouteGroup = exports.IKDSpot = exports.IKDRouteTable = exports.IKDRoutes = void 0;
const IKDRouteTable_json_1 = __importDefault(require("./json/IKDRouteTable.json"));
const IKDRoute_json_1 = __importDefault(require("./json/IKDRoute.json"));
const IKDSpot_json_1 = __importDefault(require("./json/IKDSpot.json"));
const PlaceName_json_1 = __importDefault(require("./json/PlaceName.json"));
const FishingSpot_json_1 = __importDefault(require("./json/FishingSpot.json"));
const IKDRouteGroup_json_1 = __importDefault(require("./json/IKDRouteGroup.json"));
const Item_json_1 = __importDefault(require("./json/Item.json"));
const FishParameter_json_1 = __importDefault(require("./json/FishParameter.json"));
const ItemName_json_1 = __importDefault(require("./json/ItemName.json"));
const IKDFishInfo_json_1 = __importDefault(require("./json/IKDFishInfo.json"));
const Achievement_json_1 = __importDefault(require("./json/Achievement.json"));
const IKDRouteInfo_json_1 = __importDefault(require("./json/IKDRouteInfo.json"));
const IKDSpotInfo_json_1 = __importDefault(require("./json/IKDSpotInfo.json"));
const BNpcName_json_1 = __importDefault(require("./json/BNpcName.json"));
const MJIAnimals_json_1 = __importDefault(require("./json/MJIAnimals.json"));
const MJIAnimalsInfo_json_1 = __importDefault(require("./json/MJIAnimalsInfo.json"));
const IKDContentBonus_json_1 = __importDefault(require("./json/IKDContentBonus.json"));
exports.IKDRoutes = IKDRoute_json_1.default;
exports.IKDRouteTable = IKDRouteTable_json_1.default;
exports.IKDSpot = IKDSpot_json_1.default;
exports.IKDRouteGroup = IKDRouteGroup_json_1.default;
exports.PlaceName = PlaceName_json_1.default;
exports.FishingSpot = FishingSpot_json_1.default;
exports.Item = Item_json_1.default;
exports.FishParameter = FishParameter_json_1.default;
exports.ItemName = ItemName_json_1.default;
exports.IKDFishInfo = IKDFishInfo_json_1.default;
exports.Achievement = Achievement_json_1.default;
exports.IKDRouteInfo = IKDRouteInfo_json_1.default;
exports.IKDSpotInfo = IKDSpotInfo_json_1.default;
exports.BNpcName = BNpcName_json_1.default;
exports.MJIAnimals = MJIAnimals_json_1.default;
exports.MJIAnimalsInfo = MJIAnimalsInfo_json_1.default;
exports.IKDContentBonus = IKDContentBonus_json_1.default;
